/**
 * InstructorNoShowAuditPage — standalone read-only audit surface
 * mounted at `/instructor/no-show-audit`.
 *
 * Wraps NoShowTimelineCard with the standard instructor header
 * + back navigation. Operational inspection only.
 *
 * Doctrine: NO_SHOW_DOCTRINE_SPEC.md + PLATFORM_AUTHORITY_DOCTRINE.md.
 * Append-only, learner-invisible, financially neutral.
 */
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import NoShowTimelineCard from "../components/instructor/NoShowTimelineCard";

export default function InstructorNoShowAuditPage() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="instructor-no-show-audit-page"
      className="min-h-dvh bg-slate-50 dark:bg-slate-950"
    >
      <header className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 px-4 py-3 flex items-center gap-3">
        <button
          type="button"
          onClick={() => navigate(-1)}
          data-testid="no-show-audit-back-btn"
          className="w-9 h-9 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center"
          aria-label="Back"
        >
          <ArrowLeft className="w-4 h-4" />
        </button>
        <div className="min-w-0 flex-1">
          <p className="text-base font-bold text-slate-900 dark:text-white">
            No-show audit
          </p>
          <p className="text-[12px] text-slate-500 dark:text-slate-400">
            Read-only operational history. Append-only. Learner-invisible.
          </p>
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-4 py-5">
        <NoShowTimelineCard days={30} />
      </div>
    </div>
  );
}
